module.exports = __webpack_public_path__ + "img/photo-home.9a719e5e.png";